export default __webpack_public_path__ + "static/media/olafback1.eaf6dcb8.png";